/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */

import moment from "moment";

export const DRIVER_BOOKING_LIST_COLUMNS = [
  {
    Header: "ID",
    accessor: "Employee.EmployeeId",
    id: "EmployeeId"
  },
  {
    Header: "Name",
    accessor: "Employee.FullName",
    id: "FullName"
  },

  {
    Header: "Pickup Date",
    accessor: "PickupDate",
    id: "PickupDate",
    Cell: ({ cell }) =>
      cell.value ? moment(cell.value).format("MM/DD/YY") : "",
    sortType: (a, b) => {
      const aValue = moment(a.original.PickupDate)
        .startOf("day")
        .toDate()
        .getTime();
      const bValue = moment(b.original.PickupDate)
        .startOf("day")
        .toDate()
        .getTime();
      if (aValue > bValue) return 1;
      if (bValue > aValue) return -1;
      return 0;
    }
  },
  {
    Header: "Booking Code",
    accessor: "BookingCode.Description",
    id: "BookingCode"
  },
  {
    Header: "Comment",
    id: "Comment",
    Cell: ({ row }) => row.original.BookedTrip || row.original.Comment
  },
  {
    Header: "Booking Date",
    accessor: "CreatedDateTime",
    id: "BookingDate",
    Cell: ({ cell }) =>
      cell.value
        ? moment(cell.value.slice(0, cell.value.lastIndexOf("."))).format(
            "MM/DD/YY, HH:mm"
          )
        : ""
  },
  {
    Header: "Operator",
    accessor: "Operator.UserId",
    id: "Operator.UserId",
    Cell: ({ row }) => row.original.Operator?.UserId || row.original.CreatedBy
  }
];
